module.exports = __webpack_public_path__ + "img/banner12.c8629a9b.jpg";